/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import SelectComp from 'react-select';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// Utils
import styles from './Select.module.css';
import cn from '../../../utils/cn';

const customStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: '2.75rem',
    borderColor: 'var(--color-grey-200)',
    borderRadius: '0.3rem',
    color: 'var(--color-primary-500)',
  }),
  menu: (provided) => ({
    ...provided,
    minWidth: '10.5rem',
    // Utilisez une condition pour appliquer des styles conditionnels
    ...(window.innerWidth < 768 && {
      alignItems: 'center',
      justifyContent: 'center',
      right: '10%',
    }),
  }),
};

function Select({
  id, label, ref, labelHidden, options, disabled, required, valueInput, isMulti, loading, ...props
}) {
  // Hooks
  const { t } = useTranslation();

  const mapForSelect = () => {
    let mappedOptions = [...options];
    if (!required) {
      mappedOptions = [{ label: t('global.choose'), value: '' }, ...mappedOptions];
    }

    return mappedOptions;
  };

  return (
    <>
      <label className={cn([styles.label, labelHidden ? 'visually-hidden' : ''])} htmlFor={id}>
        {label}
        {' '}
        {required ? '*' : ''}
      </label>
      <SelectComp
        styles={customStyles}
        className={styles.select}
        id={id}
        ref={ref}
        options={!loading && required ? mapForSelect() : options}
        placeholder={t('global.choose')}
        noOptionsMessage={() => t('global.no_options_available')}
        isDisabled={disabled}
        isMulti={isMulti}
        required={required}
        isLoading={loading}
        {...props}
      />
      {required ? (
        <input
          tabIndex={-1}
          autoComplete="off"
          style={{
            opacity: 0,
            width: '17.5rem',
            height: 0,
            position: 'absolute',
          }}
          value={valueInput}
          onChange={() => {}}
          onFocus={() => ref.current && ref?.current?.focus()}
          required
        />
      ) : null}
    </>
  );
}

Select.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  ref: PropTypes.func,
  labelHidden: PropTypes.bool,
  options: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  isMulti: PropTypes.bool,
  loading: PropTypes.bool,
  valueInput: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
Select.defaultProps = {
  ref: () => {},
  labelHidden: false,
  disabled: false,
  required: false,
  isMulti: false,
  valueInput: '',
  loading: false,
};

export default Select;
